var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome"}},[(_vm.user.role_type === 'OA')?_c('WelcomeOA'):_vm._e(),(_vm.user.role_type === 'leader')?_c('WelcomeLeader'):_vm._e(),(_vm.user.role_type === 'MAM')?_c('WelcomeMAM'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }